import { render, staticRenderFns } from "./checkout-comment.vue?vue&type=template&id=4e32ddd2&"
import script from "./checkout-comment.vue?vue&type=script&lang=js&"
export * from "./checkout-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e32ddd2')) {
      api.createRecord('4e32ddd2', component.options)
    } else {
      api.reload('4e32ddd2', component.options)
    }
    module.hot.accept("./checkout-comment.vue?vue&type=template&id=4e32ddd2&", function () {
      api.rerender('4e32ddd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/checkout-comment.vue"
export default component.exports